import { Slide } from "@jelly/lesson";
import theory from "../../theory";

import omni_1_normal_untreated from "./components/omni-1-normal-untreated";
import dir_1_normal_untreated from "./components/dir-1-normal-untreated";

import omni_10_normal_untreated from "./components/omni-10-normal-untreated";
import dir_10_normal_untreated from "./components/dir-10-normal-untreated";

import omni_1_high_untreated from "./components/omni-1-high-untreated";
import dir_1_high_untreated from "./components/dir-1-high-untreated";

import omni_10_high_untreated from "./components/omni-10-high-untreated";
import dir_10_high_untreated from "./components/dir-10-high-untreated";

import omni_1_normal_treated from "./components/omni-1-normal-treated";
import dir_1_normal_treated from "./components/dir-1-normal-treated";

import omni_10_normal_treated from "./components/omni-10-normal-treated";
import dir_10_normal_treated from "./components/dir-10-normal-treated";

import omni_1_high_treated from "./components/omni-1-high-treated";
import dir_1_high_treated from "./components/dir-1-high-treated";

import omni_10_high_treated from "./components/omni-10-high-treated";
import dir_10_high_treated from "./components/dir-10-high-treated";

const principle: Slide = {
  description:
    "See if/how loudspeaker directivity, the number of active loudspeakers, the operating sound pressure level, and the acoustic treatment applied in the hall influence the intelligibility of a male speaker in a mid-size sports hall with the court in the middle, and the audience at the sides. Use headphones for best experience. Use dry sound as reference. Compare the amount of direct and reverberant sound in different cases.",
  theory: theory,
  layout: {
    type: "controlsToggleExtraContent",
    options: {
      controls: [
        {
          type: "dropdown",
          items: [{ name: "omnidirectional" }, { name: "directional" }],
          options: {
            label: "Loudspeaker directivity",
          },
        },
        {
          type: "dropdown",
          items: [{ name: "1" }, { name: "10" }],
          options: {
            label: "Number of loudspeakers",
          },
        },
        {
          type: "dropdown",
          items: [{ name: "normal" }, { name: "high" }],
          options: {
            label: "Sound pressure level",
          },
        },
        {
          type: "dropdown",
          items: [{ name: "untreated" }, { name: "treated" }],
          options: {
            label: "Acoustic treatment",
          },
        },
      ],
      controlsPosition: "top",
      extraContent: [
        [
          [[], []],
          [[], []],
        ],
        [
          [[], []],
          [[], []],
        ],
      ],
      components: [
        [
          [
            [omni_1_normal_untreated, omni_1_normal_treated],
            [omni_1_high_untreated, omni_1_high_treated],
          ],
          [
            [omni_10_normal_untreated, omni_10_normal_treated],
            [omni_10_high_untreated, omni_10_high_treated],
          ],
        ],
        [
          [
            [dir_1_normal_untreated, dir_1_normal_treated],
            [dir_1_high_untreated, dir_1_high_treated],
          ],
          [
            [dir_10_normal_untreated, dir_10_normal_treated],
            [dir_10_high_untreated, dir_10_high_treated],
          ],
        ],
      ],
    },
  },
};

export default principle;
